export const questionsData = [
  {
    quizId: 'tharp',
    id: 1,
    goto: "/dashboard",
    header: "Usado tu sonar, ¿qué conclusiones puedes sacar sobre el fondo del mar?",
    options:  [
      {
        id: 1,
        text: "Que el fondo del mar probablemente tiene una topografía variada, con valles, montañas y fosas.",
        correct: true
      },
      {
        id: 2,
        text: "Que tomando medidas en varios puntos sería posible crear un mapa que muestre las divisiones submarinas entre continentes.",
        correct: false
      },
      {
        id: 3,
        text: "Que tal vez regiones que ahora están separadas antes tenían los mismos animales.",
        correct: false
      },
      {
        id: 4,
        text: "Que algunos continentes se mueven más que otros.",
        correct: false
      }
    ]
  }
];